import React, { useEffect, useState } from "react";
import SellerReviewService from "../../../services/sellerReview.service";
import "../../../styles/seller-reviews.css";

const SellerReviewSummary = ({ sellerId }) => {
    const [avgData, setAvgData] = useState({ averageRating: 0, totalReviews: 0 });
    const [recentReviews, setRecentReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (sellerId) {
            setLoading(true);

            // Fetch average rating
            SellerReviewService.getSellerAverageRating(sellerId)
                .then((res) => {
                    if (res.data.status) {
                        setAvgData(res.data.data);
                    }
                })
                .catch((err) => console.error("Error fetching average rating:", err));

            // Fetch all reviews and take the first 2 (most recent)
            SellerReviewService.getSellerReviews(sellerId)
                .then((res) => {
                    if (res.data.status) {
                        setRecentReviews(res.data.data.slice(0, 2));
                    }
                })
                .catch((err) => console.error("Error fetching reviews:", err))
                .finally(() => setLoading(false));
        }
    }, [sellerId]);

    return (
        <div className="seller-review-summary">
            <div className="avg-rating-display">
                {avgData.totalReviews > 0 ? (
                    <>
                        <span className="stars">
                            {"★".repeat(Math.round(avgData.averageRating || 0))}
                            {"☆".repeat(5 - Math.round(avgData.averageRating || 0))}
                        </span>
                        <span className="rating-value">{avgData.averageRating || "0.0"}</span>
                        <span style={{ fontSize: "14px", color: "#666" }}>
                            ({avgData.totalReviews || 0} reviews)
                        </span>
                    </>
                ) : (
                    <span style={{ fontSize: "14px", color: "#666" }}>No reviews yet</span>
                )}
            </div>
        </div>
    );
};

export default SellerReviewSummary;
